import { z } from "zod";
import { MeetingAttendeeStatus, MeetingAudienceFilter, MeetingTimeFilter } from "../enum.js";

export const meetingListQuerySchema = z
	.object({
		tab: z.enum(MeetingAudienceFilter).default(MeetingAudienceFilter.ALL),
		filter: z.enum(MeetingTimeFilter).default(MeetingTimeFilter.UPCOMING),
		cursor: z.string().optional(),
		limit: z.coerce.number().int().min(1).max(50).default(20),
	})
	.strict();

export type MeetingListQueryPayload = z.infer<typeof meetingListQuerySchema>;

export const meetingDatesQuerySchema = z
	.object({
		year: z.coerce.number().int().min(2020).max(2100),
		month: z.coerce.number().int().min(1).max(12),
	})
	.strict();

export type MeetingDatesQueryPayload = z.infer<typeof meetingDatesQuerySchema>;

export const meetingAttendeesQuerySchema = z
	.object({
		status: z.enum(MeetingAttendeeStatus).optional(),
	})
	.strict();

export type MeetingAttendeesQueryPayload = z.infer<typeof meetingAttendeesQuerySchema>;
